// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__FLYMB","colMin":"styles_colMin__2-Q7y","colCheckbox":"styles_colCheckbox__1k5ZP"};